import { Banner } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from './RyanairBanner.module.css'

export function RyanairBanner() {
  const intl = useIntl()

  return (
    <Banner color="informative" size="M" hasIcon className={styles.ryanairBannerContainer}>
      <Banner.TextsWrapper>
        <Banner.Text>
          {intl.formatMessage({ id: 'checkout_steps_ryanair_banner_information' })}
        </Banner.Text>
      </Banner.TextsWrapper>
    </Banner>
  )
}
